export default "__VITE_ASSET__4fbff8bf__"